import React from "react";

import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import QuranImg from "../../images/Quran.png";

import About from "../../sections/About/About";
import WCLQQ from "../../sections/WCLQQ/WCLQQ";
import Exclusivefeatures from "../../sections/Exclusivefeaures/Exclusivefeatures";
import EOOS from "../../sections/EOOS/EOOS";
import Testimonial from "../../sections/Testimonial/Testimonial";
import Trial from "../../sections/Bookfreetrial/Trial";
import Footer from "../../sections/Footer/Footer";
import Header from "../../sections/Header/Header";

import { Link } from "react-router-dom";
const Home = () => {
  
  return (
    <div>
      <div className="QL__Home__BG">
        <Header />
        <Container>
          <Grid container alignContent="center" justifyContent="center">
            <Grid item xs={12} md={6} alignSelf="center">
              <div className="QL__Pg__HomeMessage">
                Avail the opportunity to learn and understand Quran with the
                assistance of renowned Quran teachers.
              </div>

              <div className="QL__Pg__HomeShortMessage">
                The team behind LearnQuranQuick aims to provide the Muslim ummah
                with an affordable and efficient convenience of learning and
                understanding the Quran and its tajweed online.
              </div>
              <Link style={{ textDecoration: "none" }} to="/Registration">
                <Button className="firstbutton" variant="contained">
                  Register now
                </Button>
              </Link>
              <Link style={{ textDecoration: "none" }} to="/contact">
              <Button className="secondbutton ml-3" variant="contained">
                free Trial
              </Button>
              </Link>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              alignContent="center"
              justifyContent="center"
            >
              <div className="QL__Pg__Home__BGImg">
                <img className="QL__Pg__Home__Quranimg" src={QuranImg} />
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
      <About />
      <Exclusivefeatures />
      <WCLQQ />
      <EOOS />
      <Testimonial />
      <Trial />
      <Footer />
    </div>
  );
};

export default Home;
